import React, { useContext, useState, useEffect } from 'react';
import CollaborateQAContext from '../../ContextFiles/CollaborateQAContext';
import { Drawer, Empty, Carousel } from 'antd';
import * as Utilities from '../../Utilities';
import ENVIRONMENT from '../../../../environments';
import { LeftOutlined, RightOutlined,CheckOutlined, EditOutlined, CloseOutlined } from '@ant-design/icons';
import './ProductQA.scss'


const RejectionHistoryDrawer = (props) => {
    const { rejectionHistoryVisible, closeRejectionHistoryDrawer, customerRejectionComments, platform, product_id } = useContext(CollaborateQAContext);
    return (
        <Drawer
            className={`rejection-history-drawer ${customerRejectionComments.length == 0 ? 'empty' : ''}`}
            title={<h3 className='manrope f-18 black-33 mb-0'>Rejection History</h3>}
            placement="right"
            onClose={closeRejectionHistoryDrawer}
            visible={rejectionHistoryVisible}
            width={500}
            closable={true}
        >
            <div style={{ padding: '16px'}}>
            {
                customerRejectionComments.length == 0 ? 
                    <Empty
                    description={"No previous rejections"}
                    className="manrope f-14 display-flex j-c a-c dir-col" />
                :
                customerRejectionComments.map((ele, index) => (
                    <div style={{ marginTop: 2}}>
                        <span style={{ marginTop: 15, display: "block" }} className='note-bg-artist manrope f-12'>Date: <span style={{ color: "#276DD7", paddingLeft: 3, marginRight: 25 }}>{Utilities.convertUtcToLocalTimezone(ele.qa_time) || '-'}</span></span>
                        {ele.feedback_link &&
                        <span style={{marginLeft: '11px', marginRight: '11px'}}><span className='manrope f-12 w-700'>QA Pdf:</span> <a className='manrope f-12 blue hover-change ml-8' href={ENVIRONMENT.getBaseURL(platform) + ENVIRONMENT.PRODUCT_FEEDBACK_URI + product_id + "/" + ele.feedback_link + '.pdf'}
                                    target='_blank'>
                                    {ele.feedback_link + '.pdf'}
                                </a> </span>}
                        <div style={{ marginLeft: '11px'}} >
                            <span className='manrope f-12'><span className='manrope f-12 w-700'>Comments: </span>{ele.rejection_details}</span>
                        </div>
                        <div style={{ marginLeft: '11px'}} >
                            <span className='manrope f-12 w-700'>Attachments: </span>
                        </div>
                        {(ele.reference_files != [] && ele.reference_files != undefined) && (typeof (ele.reference_files) == "object" && Object.keys(ele.reference_files).length != 0) && 
                            <div className='rejection-carousel'>
                                <Carousel className='w-100' arrows={true} nextArrow={<RightOutlined />} prevArrow={<LeftOutlined />}>
                                    {ele.reference_files && ele.reference_files.map((file, index) => (
                                        <a style={{ color: "#276DD7", lineHeight: '120%' }}
                                            className="upload-a-settings" target="_blank"
                                            href={ENVIRONMENT.getBaseURL(platform) + ENVIRONMENT.BASE_URI + file['uid'] + '/' + encodeURI(file['name'])}>
                                            <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                                                {(file.name.includes('.jpg') || file.name.includes(".png") || file.name.includes(".PNG") || file.name.includes(".svg")) ?
                                                    <img className="product-qa-reject-image" src={ENVIRONMENT.getBaseURL(platform) + ENVIRONMENT.BASE_URI + file['uid'] + '/' + encodeURI(file['name'])} /> :
                                                    (file.name.includes(".tiff")) ? <img className="product-qa-reject-image" src={'/img/tiff_icon.png'} /> :
                                                        <img className="product-qa-reject-image" src={'/img/file-icon.png'} />}
                                            </div>
                                            <p className="manrope f-12" style={{ textAlign: 'center', color: '#555555' }}>{file.name}</p>
                                        </a>

                                    ))}
                                </Carousel>
                            </div>
                        }
                        {/* {ele.feedback_link ?
                            <div className='justify-in-start w-100 mb-4' style={{ marginTop: 2, padding: 2 }}>
                                <span className="manrope f-14 black-55 text-left ml-8" style={{ display: 'block', float: 'left' }}>
                                    Feedback:
                                </span>
                                <a className='manrope f-14 blue hover-change ml-8' href={ENVIRONMENT.getBaseURL(platform) + ENVIRONMENT.PRODUCT_FEEDBACK_URI + product_id + "/" + ele.feedback_link + '.pdf'}
                                    target='_blank'>
                                    {ele.feedback_link + '.pdf'}
                                </a>
                            </div> : ''}
                        {(ele.reference_files != [] && ele.reference_files != undefined) && (typeof (ele.reference_files) == "object" && Object.keys(ele.reference_files).length != 0) ?
                            <div className='w-100 ml-8' style={{ display: "block", marginTop: 2, marginBottom: 2, padding: 2 }} >
                                <div className='mb-10 w-100'>
                                    <span className="manrope f-12 black-33 text-left" style={{ width: "51%", float: 'left' }}>
                                        {ele.rejection_details}
                                    </span>
                                    <div style={{ float: 'left', width: '47%' }}>
                                        <Carousel className='w-100' arrows={true} nextArrow={<RightOutlined />} prevArrow={<LeftOutlined />}>
                                            {ele.reference_files && ele.reference_files.map((file, index) => (
                                                <a style={{ color: "#276DD7", lineHeight: '120%' }}
                                                    className="upload-a-settings" target="_blank"
                                                    href={ENVIRONMENT.getBaseURL(platform) + ENVIRONMENT.BASE_URI + file['uid'] + '/' + file['name']}>
                                                    <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                                                        {(file.name.includes('.jpg') || file.name.includes(".png") || file.name.includes(".PNG") || file.name.includes(".svg")) ?
                                                            <img className="upload-image-settings-reject" src={ENVIRONMENT.getBaseURL(platform) + ENVIRONMENT.BASE_URI + file['uid'] + '/' + file['name']} /> :
                                                            (file.name.includes(".tiff")) ? <img className="upload-image-settings-reject" src={'/img/tiff_icon.png'} /> :
                                                                <img className="upload-image-settings-reject" src={'/img/file-icon.png'} />}
                                                    </div>
                                                    <p className="manrope f-12" style={{ textAlign: 'center', color: '#555555' }}>{file.name}</p>
                                                </a>
        
                                            ))}
                                        </Carousel>
                                    </div>
        
                                </div>
                            </div>
                            :
                            <>
        
                                <div className='justify-in-start mt-4 ml-8' style={{ marginTop: 4 }}>
                                    <span className="manrope f-14 black-55 text-left" style={{ width: "10%", float: 'left' }}>
                                        Comments:
                                    </span>
                                    <span className="manrope f-12 black-33" style={{ textAlign: "left", float: 'left' }}>
                                        {ele.rejection_details}
                                    </span>
                                </div>
                            </>
                        } */}
                    </div>
                ))
            }
            </div>
        </Drawer>
    )
}

export default RejectionHistoryDrawer;